import React, { useEffect } from "react";

const DocuSignComplete: React.FC = () => {
  useEffect(() => {
    window.close();
  }, []);

  return (
    <div className="p-8 text-center">
      <p className="text-muted-foreground">Signing complete. You may close this tab.</p>
    </div>
  );
};

export default DocuSignComplete;
